// extracted by mini-css-extract-plugin
module.exports = {"casestudy-ck-editor":"style_casestudy-ck-editor__SOgvp"};